<template>
    <div id="cliente-editar">
        <section id="content">
            <!--start container-->
            <div class="container">
             <TituloPagina titulo="Editar lead" />
                <div class="row">
                    <lista-produtos v-model="produtos" :bloqueados="produtosBloqueados" class="col s12 m6 l2" />
                    <div class="col s12" :class="simuladorStatus == 2 ? '' : 'm6 l10'">
                        <div class="card-panel">
                            <!-- <h4 class="header">Editar lead</h4> -->

                             <div class="row" v-if="seguroAuto">
                                <div class="col m12">
                                    <h4 class="header2">Informações adicionais</h4>
                                    <div class="row">
                                        <div class="input-field col m6 s12">
                                            <input id="auto_marca" type="text" v-model="auto.auto_marca">
                                            <label for="auto_marca" :class="{active: auto.auto_marca}">Marca do veículo*</label>
                                        </div>
                                        <div class="input-field col m6 s12">
                                            <input id="auto_modelo" type="text" v-model="auto.auto_modelo">
                                            <label for="auto_modelo"
                                                :class="{active: auto.auto_modelo}">Modelo do veículo*</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col m3 s12">
                                            <masked-input type="text" id="auto_ano_fab"
                                                v-model="auto.auto_ano_fab" mask="1111" />
                                            <label for="auto_ano_fab" :class="{active: auto.auto_ano_fab}">Ano fabricação*</label>
                                        </div>
                                        <div class="input-field col m3 s12">
                                            <masked-input type="text" id="auto_ano_mod"
                                                v-model="auto.auto_ano_mod" mask="1111" />
                                            <label for="auto_ano_mod" :class="{active: auto.auto_ano_mod}">Ano modelo*</label>
                                        </div>
                                        <div class="col m3 s12">
                                            <label for="auto_renovacao">É renovação?*</label>
                                            <select class="browser-default" v-model="auto.auto_renovacao"
                                                id="auto_renovacao">
                                                <option value="Sim">Sim</option>
                                                <option value="Não">Não</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-pessoa @newdata="handleDataPessoa($event)" v-if="showForm" :pessoa="item.pessoa"></formulario-pessoa>
                                    <formulario-pedido @newdata="handleDataPedido($event)" v-if="showForm" :pedido="item.pedido"></formulario-pedido>
                                    <formulario-beneficiario @newdata="handleDataBeneficiario($event)" v-if="showForm" :beneficiario="item.beneficiario"></formulario-beneficiario>
                                    <formulario-endereco id="endereco" @newdata="handleDataEndereco($event)" v-if="showForm" :endereco="item.pessoa.endereco"></formulario-endereco>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import FormularioPessoa from '@/components/common/FormularioPessoa';
    import FormularioPedido from '@/components/common/FormularioPedido';
    import FormularioBeneficiario from '@/components/common/FormularioBeneficiario';
    import ListaProdutos from '@/components/common/ListaProdutos';
    import TituloPagina from '@/components/common/TituloPagina'
    import FormularioEndereco from '@/components/common/FormularioEndereco';
    import FormularioFuncionario from '@/components/usuarios/Formulario';
    import { get, put, post, api } from '@/helpers/api';
    import Message from '@/helpers/message';
    import Auth from '@/store/auth';

    export default {
        components: {
            FormularioPessoa,
            FormularioBeneficiario,
            FormularioEndereco,
            FormularioPedido,
            TituloPagina,
            ListaProdutos
        },
        data: () => ({
            simuladorStatus: 2,
            showForm: false,
            produtosItens: [],
            item: {},
            pessoa: {
                pessoa_nome: '',
                pessoa_cpf: '',
                pessoa_email: '',
                pessoa_sexo: '',
                pessoa_telefone: '',
                pessoa_celular: '',
                pessoa_data_nascimento: '',
                pessoa_profissao: '',
                pessoa_estado_civil: '',
                pessoa_filhos: '',
                pessoa_observacao: '',
            },
            beneficiario: {
                beneficiario_nome: '',
                beneficiario_data_nascimento: '',
            },
            endereco: {
                endereco_cep: '',
                endereco_estado: '',
                endereco_cidade: '',
                endereco_bairro: '',
                endereco_logradouro: '',
                endereco_numero: '',
                endereco_complemento: '',
            },
            produtos: [],
            produtosBloqueados: [],
             auto: {
                marca: '',
                modelo: '',
                ano_fabricacao: '',
                ano_modelo: '',
                renovacao: 1
            },
            pedido: {
                plataforma_origem: 1,
                pedido_estagio_id: '',
            },
        }),
        methods: {
            validateForm() {
                let validForm = true;
                if (this.pessoa.pessoa_nome === '') {
                    Message.messageError('Campo Nome é obrigatório');
                    validForm = false;
                }
                return validForm;
            },

            async save() {
                let obrigatoriaSelecionada = false;
                for (const produto of this.produtosItens) {
                    if(produto.produto_obrigatorio && this.produtos.includes(produto.produto_id)) {
                        obrigatoriaSelecionada = true;
                        break;
                    }
                }

                if (!obrigatoriaSelecionada) {
                    const resposta = confirm(`Se você prosseguir sem os fornecedores MAG, Omint, Sul América, Icatu, Porto e Itaú não terá acesso ao Cubix.
                    \nTem certeza que deseja seguir dessa forma?`);
                    if (!resposta) return;
                }

                await Auth.loadInfo();

                if (! this.validateForm()) return false

                let dataNascimento = null;

                if (this.pessoa.pessoa_data_nascimento !== '') {
                    dataNascimento = moment(this.pessoa.pessoa_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }

                let dataNascimentoBeneficiario = null;

                if (this.beneficiario.beneficiario_data_nascimento !== '') {
                    dataNascimentoBeneficiario = moment(this.beneficiario.beneficiario_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }

                let postData = {
                    pessoa_nome: this.pessoa.pessoa_nome,
                    pessoa_cpf: this.removerCaracteres(this.pessoa.pessoa_cpf),
                    pessoa_email: this.pessoa.pessoa_email,
                    pessoa_sexo: this.pessoa.pessoa_sexo,
                    pessoa_telefone: this.removerCaracteres(this.pessoa.pessoa_telefone),
                    pessoa_celular: this.removerCaracteres(this.pessoa.pessoa_celular),
                    pessoa_data_nascimento: dataNascimento,
                    pessoa_profissao: this.pessoa.pessoa_profissao,
                    pessoa_estado_civil: this.pessoa.pessoa_estado_civil,
                    pessoa_filhos: this.pessoa.pessoa_filhos,
                    pessoa_observacao: this.pessoa.pessoa_observacao,
                    beneficiario_nome: this.beneficiario.beneficiario_nome,
                    beneficiario_data_nascimento: dataNascimentoBeneficiario,
                    endereco_cep: this.removerCaracteres(this.endereco.endereco_cep),
                    endereco_estado: this.endereco.endereco_estado,
                    endereco_cidade: this.endereco.endereco_cidade,
                    endereco_bairro: this.endereco.endereco_bairro,
                    endereco_logradouro: this.endereco.endereco_logradouro,
                    endereco_numero: this.endereco.endereco_numero,
                    endereco_complemento: this.endereco.endereco_complemento,
                };


                await api.put(`cliente/${this.item.cliente_id}`, postData);

                let obs = null;

                if (this.seguroAuto) {

                    obs = 'Marca: ' + this.auto.auto_marca
                                + '<br>Modelo: ' + this.auto.auto_modelo
                                + '<br>Ano Fabricação:' + this.auto.auto_ano_fab
                                + ' | Ano Modelo: ' + this.auto.auto_ano_mod
                                + '<br>Renovação: ' + this.auto.auto_renovacao;
                }

                const processo = {
                    cliente_id: this.item.cliente_id,
                    empresa_indicada_id: 1,
                    produtos: this.produtos,
                    observacoes: obs,
                    plataforma_origem: this.pedido.plataforma_origem,
                    pedido_estagio_id: this.pedido.pedido_estagio_id,
                };

                if (this.produtos.length) {
                    await post('processo/indicacao', processo);
                }

                Message.messageSuccess('Cliente atualizado com sucesso.');
                this.$router.push('/gerenciamento-leads');

            },
            handleDataPessoa: function(e) {
                [
                    this.pessoa.pessoa_nome,
                    this.pessoa.pessoa_cpf,
                    this.pessoa.pessoa_email,
                    this.pessoa.pessoa_sexo,
                    this.pessoa.pessoa_telefone,
                    this.pessoa.pessoa_celular,
                    this.pessoa.pessoa_data_nascimento,
                    this.pessoa.pessoa_profissao,
                    this.pessoa.pessoa_estado_civil,
                    this.pessoa.pessoa_filhos,
                    this.pessoa.pessoa_observacao,
                ] = e;
            },
            handleDataBeneficiario: function(e) {
                [
                    this.beneficiario.beneficiario_nome,
                    this.beneficiario.beneficiario_data_nascimento,
                ] = e;
            },
            handleDataEndereco: function(e) {
                [
                    this.endereco.endereco_cep,
                    this.endereco.endereco_estado,
                    this.endereco.endereco_cidade,
                    this.endereco.endereco_bairro,
                    this.endereco.endereco_logradouro,
                    this.endereco.endereco_numero,
                    this.endereco.endereco_complemento,
                ] = e;
            },
            handleDataPedido: function (e) {
                [
                    this.pedido.plataforma_origem,
                    this.pedido.pedido_estagio_id,
                ] = e;
            },
            removerCaracteres(string) {
                if (string === '' || ! string || string === null) {
                    return '';
                }

                let stringReplace;
                stringReplace = string.split('(').join('');
                stringReplace = stringReplace.split(')').join('');
                stringReplace = stringReplace.split('-').join('');
                stringReplace = stringReplace.split('.').join('');
                stringReplace = stringReplace.split('_').join('');
                return stringReplace;
            }
        },
        async created() {

            let self = this;

            const {data: {result: {data: item}}} = await get(`cliente/${this.$route.params.id}`)

            self.item = item;
            self.showForm = true;

            this.produtosBloqueados = item.clientes_has_produtos.map(item => item.produto_id);

            this.simuladorStatus = await Auth.statusSimulador();

            const {data: {result: {data: produtos}}} = await api.get('produto')
            this.produtosItens = produtos;

        },

        computed: {
            seguroAuto() {
                return this.produtos.includes(1);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/clientes/Editar.vue